import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setAdditionalPainScaleOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IClientDataDoc } from '../../../services/clientData.service'

export function* getAdditionalPainScaleOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const painScaleResponse: IClientDataDoc = yield call([vitalsService, vitalsService.getAdditionalPainScale])
    const { entity } = painScaleResponse
    yield put(setAdditionalPainScaleOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getAdditionalPainScaleOptions() error: ${e}`))
  }
}

export function* getAdditionalPainScaleOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getAdditionalPainScaleOptions)
}
